<template>
  <div :class="wrapperClass">
    <Skeleton
      v-for="n in count"
      :key="n"
      :width="width"
      :height="height"
      :shape="shape"
      :class="skeletonClass"
      :style="style"
      :borderRadius="borderRadius"
      :size="size"
    />
  </div>
</template>

<script setup>
import Skeleton from "primevue/skeleton";

const props = defineProps({
  count: { type: Number, default: 1 },
  borderRadius: {},
  size: {},
  width: { type: String, default: "100%" },
  height: { type: String, default: "2rem" },
  shape: { type: String, default: "rect" },
  wrapperClass: { type: String, default: "" },
  skeletonClass: { type: String, default: "" },
  style: { type: Object, default: () => ({}) },
});
</script>
